import React, { FC } from 'react';
import { IconProps } from '../types';
import { iconDefaultProps } from '../const';
import IconStyled from '../icon.styled';

const IconArrowLeft: FC<IconProps> = ({ $size, ...rest }) => (
  <IconStyled {...{ $size, ...rest }}>
    <svg width={$size} height={$size} viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="m1.708 3.497h9.792c.276 0 .5.224.5.5s-.224.5-.5.5h-9.794l2.647 2.65c.195.195.195.511 0 .706-.196.196-.512.195-.707 0l-3.5-3.503c-.195-.195-.195-.512 0-.707l3.5-3.496c.195-.195.512-.195.707 0s.195.512 0 .707z"
        fill="#132122"
        fillRule="evenodd"
      />
    </svg>
  </IconStyled>
);

IconArrowLeft.defaultProps = iconDefaultProps;
IconArrowLeft.displayName = 'IconArrowLeft';

export default IconArrowLeft;
